/* eslint-disable */
import React from "react";
import { ThemePalette, ThemeShadowSizes } from "../../../theme/_Types";
import { Div } from "../../core/03-base/Div";
import { Badge } from "./Badge";
/**
 *
 * @param props
 */
export var ReleaseVersion = function (props) {
    var _a;
    var packageForReleaseVersion = require("../../../../package.json");
    return (React.createElement(Div, { className: "scl-m-release-version" },
        React.createElement(Badge, { theme: {
                palette: ThemePalette.BRAND_ACCENT,
                shadow: ThemeShadowSizes.TINY,
            } }, (_a = props.appVersion) !== null && _a !== void 0 ? _a : packageForReleaseVersion.version),
        !!props.apiVersion && !props.isCollapsed &&
            React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement(Badge, { theme: {
                        palette: ThemePalette.CONTRAST_TERTIARY,
                        shadow: ThemeShadowSizes.TINY,
                    } },
                    React.createElement("span", { style: { textTransform: "none" } },
                        props.apiLabel ? props.apiLabel : "API",
                        ":\u00A0",
                        props.apiVersion))),
        !!props.withMaryVersion && !props.isCollapsed &&
            React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement(Badge, { theme: {
                        palette: ThemePalette.CONTRAST_TERTIARY,
                        shadow: ThemeShadowSizes.TINY,
                    } },
                    React.createElement("span", { style: { textTransform: "none" } },
                        "Mary:\u00A0",
                        packageForReleaseVersion.version)))));
};
